import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AppComponent {
  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang('pt');
    // this.translate.use('pt');
  }
}
